export default __webpack_public_path__ + "static/media/primadonna2.a269b38f.jpg";